import { useTranslation } from 'react-i18next';
import { LinkSimple } from '@unified-checkout/design-system/icons/index';
import styles from './header.module.scss';

export const Header = () => {
  const { t } = useTranslation();

  return (
    <div className={styles['header']}>
      <div className={styles['header__title-section']}>
        <h1 className={styles['header__title']}>
          {t('innerLayout.paymePage.title')}
        </h1>
        <div className={styles['header__description']}>
          {LinkSimple}
          <p className={styles['header__description-text']}>
            {t('innerLayout.paymePage.description')}
          </p>
        </div>
      </div>
    </div>
  );
};

